import {
  AuthorizedApiService,
  AuthorizedFormApiService,
  AuthorizedNoTimeOutApiService,
} from "../../../services/apiServices";
import { notification } from "antd";

import {
  GET_DOCUMENTATION,
  GET_USER_MANUAL,
  UPLOAD_DOCUMENTATION,
} from "./types";

export const uploadDocumentation = (data, type) => async (dispatch) => {
  try {
    const formData = new FormData();
    formData.append("document", data);
    formData.append("documentationType", type);

    dispatch({
      type: UPLOAD_DOCUMENTATION,
      payload: type,
    });

    AuthorizedFormApiService.post("documentation", formData)
      .then((res) => {
        const { status, data } = res;
        if (status !== 201) {
          notification.error({
            message: "Something went wrong",
          });
          return;
        }

        notification.success({
          message: "Document created",
        });

        dispatch(getDocumentation());

        dispatch({
          type: UPLOAD_DOCUMENTATION,
          payload: null,
        });
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: UPLOAD_DOCUMENTATION,
          payload: null,
        });
      });
  } catch (err) {
    notification.error({
      message: "Something went wrong",
    });
    dispatch({
      type: UPLOAD_DOCUMENTATION,
      payload: null,
    });
    console.log(err);
  }
};

export const getDocumentation = () => async (dispatch) => {
  try {
    AuthorizedApiService.get("documentation")
      .then((res) => {
        const { status, data } = res;
        console.log(res.data);
        if (status !== 200) {
          notification.error({
            message: "Something went wrong",
          });
          return;
        }
        dispatch({
          type: GET_DOCUMENTATION,
          payload: data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  } catch (error) {
    notification.error({
      message: "Something went wrong",
    });
    console.log(error);
  }
};

export const documentationDelete = (id) => async (dispatch) => {
  try {
    AuthorizedApiService.delete(`documentation/${id}`)
      .then((res) => {
        const { status } = res;
        if (status !== 200) {
          notification.error({
            message: "Something went wrong",
          });
          return;
        }
        notification.success({
          message: "Docuemtation file deleted",
        });
        dispatch(getDocumentation());
      })
      .catch((err) => {
        notification.error({
          message: "Something went wrong",
        });
      });
  } catch (err) {
    notification.error({
      message: "Something went wrong",
    });
  }
};

export const documentationSendEmail = (documentation) => async (dispatch) => {
  try {
    dispatch({
      type: UPLOAD_DOCUMENTATION,
      payload: "Sending email",
    });

    AuthorizedNoTimeOutApiService.post(
      "documentation/send-email",
      documentation
    )
      .then((res) => {
        const { status, data } = res;
        if (status !== 200) {
          notification.error({
            message: "Something went wrong",
          });
          return;
        }

        notification.success({
          message: `Documents sent to ${documentation.email}`,
        });
        dispatch({
          type: UPLOAD_DOCUMENTATION,
          payload: null,
        });
      })
      .catch((err) => {
        console.log(err);
        notification.error({
          message: "Something went wrong",
        });
        dispatch({
          type: UPLOAD_DOCUMENTATION,
          payload: null,
        });
      });
  } catch (error) {
    console.log(error);
    notification.error({
      message: "Something went wrong",
    });
    dispatch({
      type: UPLOAD_DOCUMENTATION,
      payload: null,
    });
  }
};

export const getUserManual = () => async (dispatch) => {
  try {
    AuthorizedApiService.get("manual")
      .then((res) => {
        const { status, data } = res;
        if (status !== 200) {
          notification.error({
            message: "Something went wrong",
          });
          return;
        }
        dispatch({
          type: GET_USER_MANUAL,
          payload: data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  } catch (error) {
    notification.error({
      message: "Something went wrong",
    });
    console.log(error);
  }
};
